import React from 'react';
import PaymentMethodItem from './PaymentMethodItem';

const PaymentMethodsList = ({ methods = [], onToggle }) => (
  <div className="tw-flex tw-flex-col tw-gap-2.5">
    {methods.map((method) => (
      <PaymentMethodItem
        key={method.key}
        method={method}
        onToggle={() => onToggle(method.key)}
      />
    ))}
  </div>
);

export default PaymentMethodsList;
